import React, {useEffect, useRef} from 'react';
import './style.css';

import viewIcon from '../../../assets/images/camera-icon.png';
import closeIcon from '../../../assets/images/close.png';
import { useDispatch } from "react-redux";
import { setOpenedCameraList } from "../../../store/cameras/actions";
import CloseIconComponent from "../../reusable/CloseIconComponent";


interface Props {
    searchHandler: (searchHandler: React.FormEvent<HTMLInputElement>) => void
    value: string
}

const CameraListTitleComponent: React.FC<Props> = ({ searchHandler, value }) => {
    const dispatch = useDispatch();
    const ref = useRef<HTMLInputElement>(null);

    const close = () => {
        dispatch(setOpenedCameraList(false))
    };

    useEffect(() => {
        ref.current && ref.current.focus()
    }, []);

    return (
        <div className='cameralist-title-bg flex al-it-c' >
            <div className='cameralist-title-cameraIcon' >
                <img src={viewIcon} alt="camera-icon" />
            </div>
            <div className='cameralist-title-name'> CAMERAS </div>
            <div className='cameralist-title-search'>
                <input type="text"
                       onChange={ searchHandler }
                       onClick={(e) => e.stopPropagation()}
                       value={value}
                       ref={ref}
                />
            </div>
            <CloseIconComponent handler={close} />
        </div>
    )
};

export default CameraListTitleComponent